(function(){
'use strict';

function qsEscape(value){
  if(window.CSS&&typeof window.CSS.escape==='function')return window.CSS.escape(String(value||''));
  return String(value||'').replace(/(["\\])/g,'\\$1');
}

function productRootFor(handle){
  var root=null;
  if(handle){
    try{root=document.querySelector('[data-pkgp-root][data-product-handle="'+qsEscape(handle)+'"]')}catch(e){}
  }
  return root||document.querySelector('[data-pkgp-root]');
}

function cleanupGallery(productRoot){
  if(!productRoot)return;
  productRoot.querySelectorAll('[data-pkbb-slide],[data-pkbb-thumb]').forEach(function(el){el.remove()});
}

function restoreNative(handle){
  var productRoot=productRootFor(handle);
  if(!productRoot)return;
  var info=productRoot.querySelector('.pkgp__info');
  if(!info)return;
  ['.pkgp__variants','.pkgp__quantity-block','.pkgp__form'].forEach(function(sel){
    var el=info.querySelector(sel);if(el)el.classList.remove('pkbb-native-hidden');
  });
  cleanupGallery(productRoot);
}

function removeStale(sectionId,keep){
  if(!sectionId)return;
  document.querySelectorAll('[data-pkbb-root]').forEach(function(r){
    if(r!==keep&&r.dataset.sectionId===sectionId){
      var handle=r.dataset.productHandle||'';
      var productRoot=productRootFor(handle);
      r.remove();
      cleanupGallery(productRoot);
    }
  });
}

function init(root){
  if(!root)return;
  var sectionId=root.dataset.sectionId||'';
  removeStale(sectionId,root);
  if(root.dataset.pkbbReady==='1')return;
  root.dataset.pkbbReady='1';

  var productRoot=productRootFor(root.dataset.productHandle);
  if(!productRoot)return;
  var info=productRoot.querySelector('.pkgp__info'),host=root.closest('[data-pkbb-host]');
  if(!info)return;

  ['.pkgp__variants','.pkgp__quantity-block','.pkgp__form'].forEach(function(sel){
    var el=info.querySelector(sel);if(el)el.classList.add('pkbb-native-hidden');
  });

  cleanupGallery(productRoot);
  var trust=info.querySelector('.pkgp__trust');
  info.insertBefore(root,trust||null);
  root.dataset.pkbbMoved='1';
  if(host)host.style.display='none';

  var currency=root.dataset.currency||'USD',
      execution=root.dataset.discountExecution||'none',
      showSavings=root.dataset.showSavings==='true',
      busy=false;
  var active=root.querySelector('[data-pkbb-tier].is-active')||root.querySelector('[data-pkbb-tier]');

  function money(c){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format((Number(c)||0)/100)}
    catch(e){return '$'+((Number(c)||0)/100).toFixed(2)}
  }

  function variant(comp){
    var x=comp.querySelector('[data-pkbb-variant]');if(!x)return null;
    if(x.tagName==='SELECT'){
      var o=x.options[x.selectedIndex];
      return o?{id:o.value,price:Number(o.dataset.price||0),available:o.dataset.available!=='false'&&!o.disabled,image:o.dataset.image||''}:null;
    }
    return{id:x.value,price:Number(x.dataset.price||0),available:x.dataset.available!=='false',image:x.dataset.image||''};
  }

  function lines(tier){
    var a=[];
    tier.querySelectorAll('[data-pkbb-component]').forEach(function(c){
      var v=variant(c);if(!v||!v.id)return;
      var e=a.find(function(z){return z.id===v.id});
      if(e)e.quantity++;else a.push({id:v.id,quantity:1,price:v.price,available:v.available});
    });
    return a;
  }

  function configuredDiscount(tier,sub){
    var value=Math.max(0,Number(tier.dataset.discountValue||0));
    if(value<=0||sub<=0)return 0;
    return tier.dataset.discountType==='fixed'
      ?Math.min(sub,Math.round(value*100))
      :Math.min(sub,Math.round(sub*value/100));
  }

  function math(tier){
    var a=lines(tier),
        sub=a.reduce(function(s,l){return s+l.price*l.quantity},0),
        configured=configuredDiscount(tier,sub),
        preview=Math.max(0,sub-configured),
        enforced=execution==='none'?0:configured,
        checkout=Math.max(0,sub-enforced);
    return{lines:a,sub:sub,configuredDiscount:configured,previewTotal:preview,discount:enforced,total:checkout};
  }

  function text(el,v){if(el)el.textContent=v}
  function hidden(el,v){if(el)el.hidden=v}

  function updateTier(t){
    var m=math(t),
        r=t.querySelector('[data-pkbb-tier-regular]'),
        s=t.querySelector('[data-pkbb-tier-save]'),
        displayTotal=m.configuredDiscount>0?m.previewTotal:m.sub,
        previewOnly=execution==='none'&&m.configuredDiscount>0;
    text(t.querySelector('[data-pkbb-tier-total]'),money(displayTotal));
    text(r,money(m.sub));
    text(s,previewOnly?(showSavings?'Preview · Save '+money(m.configuredDiscount):'Preview only'):'Save '+money(m.configuredDiscount));
    hidden(r,!showSavings||m.configuredDiscount<=0);
    hidden(s,m.configuredDiscount<=0||(!showSavings&&!previewOnly));
  }

  function showGallery(tier){
    var url=tier.dataset.imageUrl;if(!url)return;
    var stage=productRoot.querySelector('.pkgp__stage');if(!stage)return;
    var id='pkbb-'+tier.dataset.tierId,slide=stage.querySelector('[data-pkbb-slide="'+id+'"]');
    if(!slide){
      slide=document.createElement('div');slide.className='pkgp__slide pkbb-gallery-slide';slide.dataset.pkgpSlide='';slide.dataset.mediaId=id;slide.dataset.pkbbSlide=id;
      slide.innerHTML='<img alt="" loading="lazy"><span class="pkbb-gallery-badge"></span>';
      stage.insertBefore(slide,stage.querySelector('.pkgp__arrow')||null);
    }
    slide.querySelector('img').src=url;
    slide.querySelector('.pkbb-gallery-badge').textContent=tier.dataset.tierTitle||'Bundle preview';
    productRoot.querySelectorAll('[data-pkgp-slide]').forEach(function(s){var on=s===slide;s.hidden=!on;s.classList.toggle('is-active',on)});
    var thumbs=productRoot.querySelector('.pkgp__thumbs');
    if(!thumbs){thumbs=document.createElement('div');thumbs.className='pkgp__thumbs';var gallery=productRoot.querySelector('[data-pkgp-gallery]');if(gallery)gallery.appendChild(thumbs)}
    if(!thumbs)return;
    var thumb=thumbs.querySelector('[data-pkbb-thumb="'+id+'"]');
    if(!thumb){
      thumb=document.createElement('button');thumb.type='button';thumb.className='pkgp__thumb';thumb.dataset.pkgpThumb='';thumb.dataset.mediaId=id;thumb.dataset.pkbbThumb=id;
      thumb.innerHTML='<img alt="" width="80" height="80" loading="lazy">';thumb.addEventListener('click',function(){showGallery(tier)});thumbs.appendChild(thumb);
    }
    thumb.querySelector('img').src=url;
    productRoot.querySelectorAll('[data-pkgp-thumb]').forEach(function(b){var on=b===thumb;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false')});
  }

  function update(){
    root.querySelectorAll('[data-pkbb-tier]').forEach(updateTier);
    if(!active)return;
    var m=math(active),
        row=root.querySelector('[data-pkbb-summary-discount-row]'),
        totalLabel=root.querySelector('[data-pkbb-summary-total-label]'),
        note=root.querySelector('[data-pkbb-execution-note]'),
        previewOnly=execution==='none'&&m.configuredDiscount>0,
        displayTotal=m.configuredDiscount>0?m.previewTotal:m.sub;

    text(root.querySelector('[data-pkbb-summary-regular]'),money(m.sub));
    text(root.querySelector('[data-pkbb-summary-discount]'),'-'+money(m.configuredDiscount));
    text(totalLabel,previewOnly?'Offer preview':'Bundle total');
    text(root.querySelector('[data-pkbb-summary-total]'),money(displayTotal));
    text(root.querySelector('[data-pkbb-add-total]'),money(m.total));
    hidden(row,!showSavings||m.configuredDiscount<=0);

    if(note&&execution==='none'){
      var base=note.dataset.baseNote||'Bundle selections are added at Shopify\'s current product prices.';
      text(note,previewOnly?'Preview only — '+base:base);
    }

    var code=String(active.dataset.discountCode||'').trim(),
        bad=m.lines.length===0||m.lines.some(function(l){return !l.available}),
        missing=execution==='discount_code'&&!code,
        btn=root.querySelector('[data-pkbb-add]'),
        status=root.querySelector('[data-pkbb-status]');

    if(btn){
      btn.disabled=busy||bad||missing;
      var sp=btn.querySelector('span');
      if(sp)sp.textContent=busy?'Adding…':bad?'Bundle unavailable':missing?'Discount code required':root.dataset.addLabel;
    }
    if(missing){text(status,'Add a matching Shopify discount code to this tier in Theme Editor.');hidden(status,false)}
    else if(bad){text(status,'One or more selected options are sold out.');hidden(status,false)}
    else hidden(status,true);
  }

  function select(t){
    active=t;
    root.querySelectorAll('[data-pkbb-tier]').forEach(function(x){
      var on=x===t;x.classList.toggle('is-active',on);
      var b=x.querySelector('[data-pkbb-tier-select]');if(b)b.setAttribute('aria-pressed',on?'true':'false');
    });
    update();showGallery(t);
  }

  function add(){
    if(busy||!active)return;
    var m=math(active),code=String(active.dataset.discountCode||'').trim();
    if(!m.lines.length||m.lines.some(function(l){return !l.available})||(execution==='discount_code'&&!code)){update();return}
    busy=true;update();
    var title=active.dataset.tierTitle||'Aarna Bundle',tid=active.dataset.tierId||'',items=m.lines.map(function(l){
      return{id:l.id,quantity:l.quantity,properties:{'_Aarna bundle':title,'_Aarna bundle tier':tid}};
    });
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)return r.json().then(function(b){throw new Error(b.description||'Could not add bundle')});return r.json()})
      .then(function(){
        if(execution==='discount_code'&&code){location.assign('/discount/'+encodeURIComponent(code)+'?redirect=/cart');return}
        document.dispatchEvent(new CustomEvent('peekora:cart:updated',{detail:{open:true}}));
        if(window.AarnaMiniCart&&window.AarnaMiniCart.open)setTimeout(function(){window.AarnaMiniCart.open()},80);
      })
      .catch(function(e){var s=root.querySelector('[data-pkbb-status]');text(s,e.message||'Could not add bundle.');hidden(s,false)})
      .finally(function(){busy=false;update()});
  }

  productRoot.addEventListener('click',function(e){
    var nativeThumb=e.target.closest('[data-pkgp-thumb]'),arrow=e.target.closest('[data-pkgp-prev],[data-pkgp-next]');
    if((nativeThumb&&!nativeThumb.dataset.pkbbThumb)||arrow){
      productRoot.querySelectorAll('[data-pkbb-slide]').forEach(function(s){s.hidden=true;s.classList.remove('is-active')});
    }
  },true);

  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-pkbb-tier-select]');if(b){select(b.closest('[data-pkbb-tier]'));return}
    if(e.target.closest('[data-pkbb-add]'))add();
  });

  root.addEventListener('change',function(e){
    if(e.target.matches('[data-pkbb-variant]')){
      var o=e.target.options&&e.target.options[e.target.selectedIndex],img=o&&o.dataset.image,c=e.target.closest('[data-pkbb-component]');
      if(img&&c){var im=c.querySelector('.pkbb__component-media img');if(im)im.src=img}
      update();
    }
  });

  update();if(active)showGallery(active);
}

function scan(){document.querySelectorAll('[data-pkbb-root]').forEach(init)}

function unloadSection(event){
  var sectionId=event&&event.detail&&event.detail.sectionId;
  if(!sectionId)return;
  var handles=[];
  document.querySelectorAll('[data-pkbb-root]').forEach(function(root){
    if(root.dataset.sectionId===sectionId){
      handles.push(root.dataset.productHandle||'');
      var productRoot=productRootFor(root.dataset.productHandle||'');
      root.remove();cleanupGallery(productRoot);
    }
  });
  setTimeout(function(){
    handles.forEach(function(handle){
      var selector='[data-pkbb-root][data-product-handle="'+qsEscape(handle)+'"]';
      var remains=false;try{remains=!!document.querySelector(selector)}catch(e){}
      if(!remains)restoreNative(handle);
    });
  },0);
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
document.addEventListener('shopify:section:unload',unloadSection);
document.addEventListener('shopify:section:load',scan);
})();